export default {
    common: {
        general: {
            Home: 'LE Home',
        },
    },
};
